import * as React from 'react';
import styled from '@emotion/styled';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import { useLocation } from 'react-router-dom';
import StyledToolTips from '../../utils/tooltip/StyledToolTip';
import Logo from './Logo';
import { AuthStatus, useProvideAuth } from '../../utils/authentication/use-Auth';

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #4b286d;
  padding: 0 1rem;
  text-align: center;
`;

const LogoIconStyle = {
  color: '#ffffff',
  bgcolor: '#4B286D',
};

const Header = () => {
  const auth = useProvideAuth();
  const location = useLocation();
  return (
    <StyledHeader>
      <Logo />
      <AuthStatus>
        {auth.isAuthenticated ? (
          <StyledToolTips title="Logout" enterDelay={100} arrow>
            <LogoutIcon sx={LogoIconStyle} />
          </StyledToolTips>
        ) : (
          !(location.pathname === '/dashboard/logout') && (
            <StyledToolTips title="Login" enterDelay={100} arrow>
              <LoginIcon sx={LogoIconStyle} />
            </StyledToolTips>
          )
        )}
      </AuthStatus>
    </StyledHeader>
  );
};

export default Header;
